import { useMemo } from 'react';
import type { ShopifyOfferDto } from '../../../../offer.types';
import type { PaymentBadgeDto } from '../../../../services/checkoutConfig/checkoutConfig.types';

export const useFooterData = (shopifyOffer: ShopifyOfferDto, paymentBadgesOverride?: PaymentBadgeDto[]) => {
  const store = shopifyOffer.store;

  const paymentBadges: PaymentBadgeDto[] = useMemo(
    () => paymentBadgesOverride ?? shopifyOffer.checkoutTheme.paymentBadges,
    [paymentBadgesOverride, shopifyOffer.checkoutTheme.paymentBadges],
  );

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return {
    store,
    paymentBadges,
    currentYear,
  };
};
